/* global location */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import findIndex from "lodash/findIndex";
import pickBy from "lodash/pickBy";
import sumBy from "lodash/sumBy";
import map from "lodash/map";
export function getSlideIndex(id, state) {
    var slides = state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    });
    return findIndex(slides, {
        id: id
    });
}
export function getChapterIndexes(chapterId, state) {
    var slides = state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    });
    var chapter = state.nodes.find(function(n) {
        return n.id === chapterId;
    });
    var indices = map(chapter.c, function(id) {
        return findIndex(slides, {
            id: id
        });
    });
    if (indices !== undefined) {
        if (indices.length === 1) {
            return "".concat(indices[0] + 1);
        } else if (indices.length > 1) {
            var firstIndex = indices[0] != null ? indices[0] + 1 : "";
            var lastIndex = indices[indices.length - 1] != null ? indices[indices.length - 1] + 1 : "";
            return "".concat(firstIndex, "-").concat(lastIndex);
        } else {
            return "";
        }
    } else {
        return "";
    }
}
export function isSlideAvailable(slide, state) {
    var _state_exam, _state_exam1, _state_examInteractions_state_exam_id, _state_nodes_find;
    var c = location.search.match(/c=(\d+)/);
    var cid = c && parseInt(c[1], 10);
    var currentExamInteractions = ((_state_exam = state.exam) === null || _state_exam === void 0 ? void 0 : _state_exam.id) ? state.examInteractions[state.exam.id] : [];
    var numberOfExamInteractions = ((_state_exam1 = state.exam) === null || _state_exam1 === void 0 ? void 0 : _state_exam1.id) && ((_state_examInteractions_state_exam_id = state.examInteractions[state.exam.id]) === null || _state_examInteractions_state_exam_id === void 0 ? void 0 : _state_examInteractions_state_exam_id.length) || 0;
    // TO DO: we need to refactor the logic below, ideally split it into several smaller functions
    // that check if a specific condition is true to make this more readable
    return !!state.cbook && !!slide && !!((!state.exam || state.exam.state !== "running") && getSlideIndex(slide.id, state) >= 0 && (state.cbook.mode === "free" || !!location.pathname.match(new RegExp("(preview/".concat(state.cbook.slug, "|review/api)"))) && (cid === slide.id || window.disableLinear) || !slide.required_nodes || !slide.required_nodes.length || slide.required_nodes.every(function(id) {
        return state.completed.indexOf(id) > -1;
    })) || // if the current slide has been answered, always allow navigation
    state.exam && state.exam.state === "running" && !!state.exam.answers.find(function(a) {
        return a.id === slide.id;
    }) || // if navigation is allowed, always allow navigation as long as the requested slide is an exam interaction (prevent jumping out of the exam or to the results if not all questions are answered)
    state.exam && state.exam.state === "running" && ((_state_nodes_find = state.nodes.find(function(n) {
        var _state_exam;
        return n.id === ((_state_exam = state.exam) === null || _state_exam === void 0 ? void 0 : _state_exam.id);
    })) === null || _state_nodes_find === void 0 ? void 0 : _state_nodes_find.allow_navigation) && !!(currentExamInteractions === null || currentExamInteractions === void 0 ? void 0 : currentExamInteractions.find(function(q) {
        return q.id === slide.id;
    })) && numberOfExamInteractions > 0 && state.exam.answers.length < numberOfExamInteractions);
}
export function getPathTo(slide, state) {
    var nodes = state.nodes;
    var path = [];
    var rec = function(_slide) {
        var _slide_required_nodes;
        if (slide.id !== _slide.id) {
            path.push(_slide.id);
        }
        if (_slide === null || _slide === void 0 ? void 0 : (_slide_required_nodes = _slide.required_nodes) === null || _slide_required_nodes === void 0 ? void 0 : _slide_required_nodes.length) {
            var _loop = function(i) {
                if ((_slide === null || _slide === void 0 ? void 0 : _slide.required_nodes) && _slide.required_nodes[i]) {
                    var n = nodes.find(function(n) {
                        return n.id === _slide.required_nodes[i];
                    });
                    if (n) {
                        rec(n);
                    }
                }
            };
            var _slide_required_nodes1;
            for(var i = 0; i < (_slide === null || _slide === void 0 ? void 0 : (_slide_required_nodes1 = _slide.required_nodes) === null || _slide_required_nodes1 === void 0 ? void 0 : _slide_required_nodes1.length); i++)_loop(i);
        }
    };
    rec(slide);
    return path.reverse().filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).reverse();
}
export function getNearestAvailable(slide, state) {
    var slides = state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    });
    var path = getPathTo(slide, state);
    if (!state.completed.length) {
        return [
            slides[0],
            path.length
        ];
    }
    var slidePath = path.map(function(id) {
        return slides.find(function(n) {
            return n.id === id;
        });
    }).filter(function(n) {
        return !!n && isSlideAvailable(n, state);
    });
    return [
        slidePath[0],
        path.length + 1 - slidePath.length
    ];
}
export function isExamCompleted(slide, state) {
    var _state_api;
    if (slide.target_type !== "Exam") {
        return false;
    }
    var examStatus = (_state_api = state.api) === null || _state_api === void 0 ? void 0 : _state_api.getSlideStatus(slide.id);
    if (slide.completion_required && !slide.success_required) {
        return examStatus === "passed" || examStatus === "failed";
    } else if (slide.success_required) {
        return examStatus === "passed";
    } else {
        return slide.do_not_track || examStatus !== "not attempted";
    }
}
export function isSlideCompleted(slide, state) {
    return slide.do_not_track || state.completed.indexOf(slide.id) > -1;
}
export function setCourseStatus(state) {
    if (state.cbook.use_credit_points) {
        state.nodes.filter(function(n) {
            return n.target_type === "Filter" && !n.do_not_track;
        }).map(function(chapter) {
            if (chapter.c && chapter.c.every(function(val) {
                return state.completed.includes(val);
            })) {
                var chapterPercentage = (chapter.credit_points * 100 / state.cbook.credit_points).toFixed(2);
                if (state.api) {
                    state.api.completeChapter(chapter.id, Number(chapterPercentage));
                }
            }
        });
        if (state.api) {
            var _state_api, _state_api1;
            var currentValue = Number((_state_api = state.api) === null || _state_api === void 0 ? void 0 : _state_api.getCurrentPercentage());
            var masteryScore = Number((_state_api1 = state.api) === null || _state_api1 === void 0 ? void 0 : _state_api1.getMasteryScore());
            if (currentValue >= masteryScore) {
                state.api.setCBookStatus("passed");
            } else {
                state.api.setCBookStatus("failed");
            }
        }
    } else {
        var status = "incomplete";
        var slides = state.nodes.filter(function(n) {
            return !/Exam|Filter/.test(n.target_type);
        });
        if (slides.every(function(n) {
            return isSlideCompleted(n, state);
        })) {
            status = "completed";
        }
        var exams = state.nodes.filter(function(n) {
            return n.target_type === "Exam";
        });
        if (status === "completed" || exams.every(function(n) {
            var _state_examData_n_id;
            return state.examData[n.id] && n.max_attempts && ((_state_examData_n_id = state.examData[n.id]) === null || _state_examData_n_id === void 0 ? void 0 : _state_examData_n_id.tries) && n.max_attempts <= state.examData[n.id].tries;
        })) {
            if (exams.length && exams.every(function(n) {
                return isExamCompleted(n, state);
            })) {
                status = "passed";
            } else if (exams.length) {
                status = "failed";
            }
        }
        if (state.api) {
            state.api.setCBookStatus(status);
        }
    }
}
export function checkExamAttempts(state) {
    var examData = state.examData[state.currentSlide];
    if (examData.tries > 1) {
        // getting the correct answers.
        var interactions = state.examInteractions[state.currentSlide];
        var questions = pickBy(interactions, function(v, _) {
            return examData.answers.includes(parseInt(v.id, 10));
        });
        var total = sumBy(Object.entries(questions).map(function(param) {
            var _param = _slicedToArray(param, 2), _ = _param[0], value = _param[1];
            return value;
        }), "credit_points");
        var totalPointsInPercentage = (total * 100 / state.cbook.credit_points).toFixed(2);
        if (total > 0 && state.api) {
            state.api.removePoints(Number(totalPointsInPercentage));
        }
    }
}
export function addQuestionPoints(questionId, state) {
    var cbookCreditPoints = state.cbook.credit_points;
    var exam = state.nodes.filter(function(node) {
        return node.id === state.currentSlide && !node.do_not_track;
    })[0];
    if (exam && exam.success_required || exam && exam.success_required) {
        var questionPercentage = (state.contents[questionId].credit_points * 100 / cbookCreditPoints).toFixed(2);
        state.api.addPoints(Number(questionPercentage));
    }
}
export function getTrackableSlidesInChapter(chapter, state) {
    var arr = [];
    var rec = function(node) {
        if (!node) return;
        if (node.c && node.c.length) {
            var i = 0;
            while(i < node.c.length){
                rec(state.nodes.find(function(n) {
                    return n.id === node.c[i];
                }));
                i++;
            }
        } else if (!node.do_not_track) {
            arr.push(node.id);
        }
    };
    rec(chapter);
    return arr;
}
